<div [attr.data-id]="field.dataId" class="text-input">
  <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"></ngx-editor-menu>
  <hr class="v2-mb-2 hr" />
  <ngx-editor [editor]="editor" [formControl]="formControl" data-id="editor"></ngx-editor>
</div>
